/**
 * Utilidades de validación
 */

import { traduccionesMetal } from "../../constants/Constants.js";
import { notify } from "../ui/notify";

/**
 * Valida si el peso está dentro del margen permitido
 * @param {number} weight - Peso a validar
 * @param {number} bruto - Peso bruto de referencia
 * @returns {boolean} true si el peso es válido, false en caso contrario
 */
export function correctWeight(weight, bruto) {
  const difference = Math.abs(weight - bruto);
  const margin = bruto * 0.05; // 5% de diferencia permitida

  if (difference <= margin) {
    // El peso se mantiene dentro del margen permitido
    return true;
  } else {
    notify.warn("Se han superado los márgenes de peso");
    return false;
  }
}

/**
 * Traduce nombres de metales
 * @param {string} nombre - Nombre del metal
 * @param {string} lang - Idioma (por defecto "es")
 * @returns {string} Nombre traducido
 */
export function traducirMetal(nombre, lang = "es") {
  if (lang === "es") return nombre;

  return nombre
    .toLowerCase()
    .split(" ")
    .map((palabra) => traduccionesMetal[palabra] || palabra)
    .map((word, i, arr) => {
      // Capitalizar si es la primera palabra o viene después de un punto
      if (i === 0 || arr[i - 1].includes(".")) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word;
    })
    .join(" ");
}

/**
 * Verifica si una URL existe
 * @param {string} url - URL a verificar
 * @returns {Promise<boolean>} true si la URL existe, false en caso contrario
 */
export async function urlExiste(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}
